import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgResultadoPetTratamiento from "../../assets/tests/scn4/resultado-pet-tratamiento-next.jpg";
import imgEstudiosDra from "../../assets/tests/scn4/resultado-pet-tratamiento-dra.jpg";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconMicroscope, IconClipboardList } from "@tabler/icons-react";

function Scenario4Retroalimentacion({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div
            className="col-md-6 d-flex flex-column justify-content-around align-items-start px-4"
          >
            <div className="d-flex flex-column align-items-start">
              <p
                className="position-relative txtTexto2"
              >
                Te invitamos a revisar la siguiente imagen, que muestra los resultados del
              </p>
              <p className="txtTitulos blue bold" style={{ borderRadius: "10px"}}>PET/CT PSMA<br/>(respuesta al tratamiento)</p>
              <img src={imgEstudiosDra} className="rounded shadow mt-4" style={{width: "100%"}}></img>
            </div>
            <div className="mb-5 d-flex align-items-center justify-content-end w-100">
              {/* Botón siguiente */}
              <NextButton
                navigateTo={ROUTES.SCENARIO4_RADIOTERAPIA}
                activeScenario={activeScenario}
                color="blue"
              />
            </div>
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-start px-4 bgCircleBlue pt-4">
            <img src={imgResultadoPetTratamiento} className="rounded shadow" style={{ maxWidth: "93%", borderRadius: "12px" }}></img>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario4Retroalimentacion);
